import essApi from "../axios/essApi";

class SkillService {

    async getSkills() {
        return Promise.resolve(essApi.get(`skills`));
    }

    async findOrCreateSkill(title) {
        return Promise.resolve(essApi.post(`skills/find-or-create`, { title }));
    }
    ///user-Skill-by-user-id/
    async getSkillsById(reqBody) {
        return Promise.resolve(essApi.get(`user-Skill-by-user-id/${reqBody}`));
    }

    async getUserSkillsList() {
        return Promise.resolve(essApi.get(`user-Skill`));
    }
    async addBulkSkills(payload) {
        return Promise.resolve(essApi.post(`user-skill-in-bulk`, payload));
    }

    async addCommunicationSkillsRating(payload){
        return Promise.resolve(essApi.put(`user-Skill`,payload))
    }

    async deleteSkill(param) {
        return Promise.resolve(essApi.delete(`user-Skill/${param}`));
    }

    async updateSkill(payload) {
        return Promise.resolve(essApi.put(`user-Skill/${payload.id}`,payload));
    }
    async updateSkillAuto(payload) {
        return Promise.resolve(essApi.put(`user-Skill`,payload));
    }
    async addCommunicationSkillsRatings(payload){
        return Promise.resolve(essApi.put(`/users/${payload.id}`,payload))
    }
    async getOverAllRatings(payload){
        return Promise.resolve(essApi.get(`/user/overallRating/${payload.id}`,payload))
    }
    

}

export default SkillService;
